<template>
  <b-row>
    <b-col sm="12">
      <label for="page-name" style="padding-top: 7px">
        <span class="fs-dbb-20">{{
          $t("engine.managePage.pageAddEdit.seo.lblPreview", languageEngine)
        }}</span
        >&nbsp;&nbsp;&nbsp;
        <span class="text-hint fs-db-20" style="font-weight: normal">({{ languageUse && languageUse.toUpperCase() }})</span>
      </label>
    </b-col>
    <b-col sm="12">
      <PreviewGoogle :url="url" :title="title" :description="description" />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import PreviewGoogle from "@components_system/Shared/Tools/PreviewGoogle/PreviewDektop.vue";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    PreviewGoogle,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
      domain: "design/page/domain",
    }),
    title() {
      if (!this.data.properties.seo.title) {
        if (this.data.properties.name) {
          return this.data.properties.name;
        } else {
          return this.$t(
            "engine.managePage.pageAddEdit.seo.lblPreviewTitle",
            this.languageEngine
          );
        }
      }
      if (this.data.properties.seo.title.length > 77) {
        return `${this.data.properties.seo.title.substring(0, 77)} ...`;
      }
      return this.data.properties.seo.title;
    },
    description() {
      if (!this.data.properties.seo.description) {
        if (this.data.properties.name) {
          return this.data.properties.name;
        } else {
          return this.$t(
            "engine.managePage.pageAddEdit.seo.lblPreviewDes",
            this.languageEngine
          );
        }
      }

      if (this.data.properties.seo.description.length > 199) {
        return `${this.data.properties.seo.description.substring(0, 199)} ...`;
      }
      return this.data.properties.seo.description;
    },
    url() {
      if (this.data.properties.url) {
        return this.data.properties.url;
      } else {
        return "example";
      }
    },
  },
};
</script>

<style>
</style>